import glam from 'glamorous';
// import { Sizes } from 'module/View/Common';

export const Wrapper = glam.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.8rem 0.4rem 0 0',
  fontSize: '1.2rem',
  // marginTop: Sizes.smallGutter,
});

export const IconLink = glam.a({});



// WEBPACK FOOTER //
// ./src/module/View/Menu/Items/ItemSocialLinks.s.ts